import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Button } from '@dnb/eufemia'
import { Icon } from '@dnb/eufemia/components';
import { home } from '@dnb/eufemia/icons';
import {bell as Bell} from '@dnb/eufemia/icons';
// import { chevron_right as ChevronRight } from '@dnb/eufemia/icons';
import DnbStatusLink from '../dnb-status-link/DnbStatusLink';
import CustomDnbLogo from '../../assets/icons/CustomDnbLogo';
//import CustomDnbLogoIcon from 'url:../../assets/icons/custom_dnb_logo.svg';
//import CustomDnbLogoIcon from './custom_dnb_logo.svg';
//const CustomDnbLogoIcon = new URL('./custom_dnb_logo.svg', import.meta.url);

import './header.css';

const Header = () => {
  const { t, i18n } = useTranslation();
  return (
    <header className="dnb-header">
      <div className="dnb-center-content">
        <div className="dnb-header__content">
          <Link
            to="/"
            aria-label={t('DNB Status front page')}
            title={t('DNB Status front page')}
            className="dnb-main-title"
          >
            <h1>DNB Status</h1>
            <span className="dnb-main-title__logo">
          <Icon icon={CustomDnbLogo} size="xx-large"/>
            </span>
            <span className="dnb-main-title__sub">Status</span>
          </Link>
          <Button text="dnb.no" icon={home} variant="secondary" icon_position="left" href="https://www.dnb.no/" target="_blank"/>
          
        </div>
      </div>
    </header>
  );
};

export default Header;
         